import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Globe, MapPin, ArrowRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';

const ActivitiesLanding = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/activities/public-list`);
        setActivities(res.data);
      } catch { /* no public activities yet */ }
      finally { setLoading(false); }
    };
    load();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50" data-testid="activities-landing">
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-5xl mx-auto px-4 py-5 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-emerald-700">Sefer Tunisia</h1>
            <p className="text-sm text-gray-500">Activities & Experiences in Djerba</p>
          </div>
          <Globe className="w-8 h-8 text-emerald-600" />
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-12">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">Discover Our Activities</h2>
          <p className="text-gray-600 max-w-xl mx-auto">
            Explore unique experiences in Djerba. Book through our trusted partners.
          </p>
        </div>

        {loading ? (
          <div className="text-center py-12 text-gray-400">Loading...</div>
        ) : activities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {activities.map(a => (
              <div key={a.id} className="bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-lg transition">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-lg font-semibold text-gray-900">{a.name}</h3>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium
                    ${a.type === 'trip' ? 'bg-blue-100 text-blue-700' : a.type === 'service' ? 'bg-purple-100 text-purple-700' : 'bg-emerald-100 text-emerald-700'}`}>
                    {a.type}
                  </span>
                </div>
                {a.description && <p className="text-sm text-gray-500 mb-3">{a.description}</p>}
                <div className="flex items-center justify-between pt-3 border-t">
                  <span className="text-xl font-bold text-emerald-600">{a.price} {a.currency}</span>
                  <MapPin className="w-4 h-4 text-gray-400" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 text-gray-400">
            <Globe className="w-12 h-12 mx-auto mb-3 opacity-30" />
            <p>Activities coming soon!</p>
          </div>
        )}
      </div>

      <div className="bg-white border-t mt-12 py-8 text-center">
        <p className="text-sm text-gray-500">
          Powered by <span className="font-semibold text-emerald-600">Sefer Tunisia</span>
        </p>
      </div>
    </div>
  );
};

export default ActivitiesLanding;
